import {useEffect, useState} from "react";
import Web3 from 'web3';
import { Switch, Route, useLocation,matchPath, Redirect} from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Homepage from './Homepage.js';
import Gallery from './Gallery.js';
import About from './About.js';
import Buy from './Buy.js';
import Header from './Header.js';
import contractAbi from './extra/contractAbi.js';
import contractMinterAbi from './extra/minterAbi.js';

import Canvas from './Canvas.js';
import GifExport from './GifExport.js'

const Modal = props => {
  const handleCloseClick = () => {
    props.passSetModal({enabled:false, message:""});
  }
  //       <button className="modal-close is-large" aria-label="close" onClick={handleCloseClick}></button>

  return (
    <div className="modal has-text-black is-active">
      <motion.div 
      initial={{opacity:0}}
      animate={{opacity:1}} 
      transition={{duration:0.35}}
      exit={{opacity:0}}
      className="modal-background">
      </motion.div>
      <motion.div
        initial={{y:20, opacity:0}}
        animate={{y:0, opacity:1}} 
        transition={{duration:0.3, delay:0.1}}
        exit={{y:-40, opacity:0}}
        className="modal-content sp-modal p-5">
        <p className="is-size-7">{(!props.passModal.type) ? "Ouch! Something has gone wrong!" : "Share your Spectron video" }</p>
        <p className="is-size-4 is-family-secondary mt-4">{props.passModal.message}</p>
        <button className="button is-size-7 is-primary is-rounded mt-5" onClick={handleCloseClick}>OK</button>
      </motion.div>
    </div>
  )
}

const Forbidden = props => {
  return (
    <motion.section 
      className="has-text-black"
      initial={{y:50, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.1, duration:0.5}}  
    >
    <div className="container has-text-centered">
        <p className="is-size-1 is-size-3-mobile">Error!</p>
        <p className="is-size-7">You are not connected to the blockchain. Please connect to Metamask before trying to mint a new token.</p>
    </div>
    </motion.section>
  )
}

const Intro = props => {
  return (
  <section className="sp-loading has-text-black has-text-centered is-flex is-justify-content-center is-align-content-center">
  <div className="container has-text-centered sp-centered">
      <p className="is-size-1 is-size-3-mobile">Spectron</p>
      <p className="is-size-7">{props.loadingStatus}</p>
      <p className="sp-loader mt-4"></p>
  </div>
  </section>
  )
}

function App() {
  const location = useLocation();
  const [isGifPage, setIsGifPage] = useState(false);
  // Modal dialog
  const [modal, setModal] = useState({enabled:false, message:""});
  // Main states
  const [canvas, setCanvas] = useState({});
  const [tokens, setTokens] = useState([]);
  // Loaded state
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("Loading data...");
  // Web3 blockchain
  const [isConnectedMetamask, setIsConnectedMetamask] = useState(false);
  const [web3Metamask, setWeb3MetaMask] = useState(undefined);
  const [isMetamaskInstalled, setIsMetamaskInstalled] = useState(false);
  const [web3Infura, setWeb3Infura] = useState(undefined);
  const [web3InfuraContract, setWeb3InfuraContract] = useState(undefined);
  const [artblockProjectInfo, setArtblockProjectInfo] = useState({});
  const [accountsMetamask, setAccountsMetamask] = useState([]);

  // Artblocks data
  const blockchain = {
    artblock: {
      address: "0xa7d8d9ef8D8Ce8992Df33D8b8CF4Aebabd5bD270", //"0x152eee3dcc5526efd646e9b45c9a9672bffcc097", //"0x0d86198A785D9Cabf3ce9A2032D6cf4a1Ec1235b",
      abi: contractAbi,
      minter: "0x091dcd914fCEB1d47423e532955d1E62d1b2dAEf", // "0xa58EC37211A040aBB9f0c1931Ce83CF094E68ff1", //0x571E0Cc6827946b65CF3756Bb1AFe753Edb7B474",
      minterAbi: contractMinterAbi,
      projectId: 17, //3, //12,
      tokenPrefix: 17000000, // 3000000, //12000000,
      projectTokenInfo: artblockProjectInfo
    },
    metamask: {
      setWeb3: setWeb3MetaMask,
      setIsConnected: setIsConnectedMetamask,
      setAccounts: setAccountsMetamask,
      setIsInstalled: setIsMetamaskInstalled,
      isConnected: isConnectedMetamask,
      isInstalled: isMetamaskInstalled,
      web3: web3Metamask,
      accounts: accountsMetamask
    },
    infura: {
      web3: web3Infura,
      contract: web3InfuraContract
    },
    opensea: {
      api: "https://api.opensea.io/api/v1/asset/" + "0xa7d8d9ef8D8Ce8992Df33D8b8CF4Aebabd5bD270",
      //api: "https://rinkeby-api.opensea.io/api/v1/asset/" + "0xa58EC37211A040aBB9f0c1931Ce83CF094E68ff1" + "/", //0x0d86198A785D9Cabf3ce9A2032D6cf4a1Ec1235b/",
      // address: "https://testnets.opensea.io/assets/" + "0xa58EC37211A040aBB9f0c1931Ce83CF094E68ff1" + "/" //0x0d86198a785d9cabf3ce9a2032d6cf4a1ec1235b/" 
      address: "https://opensea.io/assets/" + "0xa7d8d9ef8D8Ce8992Df33D8b8CF4Aebabd5bD270" + "/" //0x0d86198a785d9cabf3ce9a2032d6cf4a1ec1235b/" 
    }, 
    etherscan: {
      address: "https://etherscan.io/address/" // "https://rinkeby.etherscan.io/address/"
    }
  }
  
  const getOpenseaData = async(_tokens) => {
    // Make query string
    let queryString = "https://api.opensea.io/assets/?asset_contract_address=" + blockchain.artblock.address; // 0x0d86198a785d9cabf3ce9a2032d6cf4a1ec1235b";
    
    //let queryString = "https://rinkeby-api.opensea.io/api/v1/assets/?asset_contract_address=" + blockchain.artblock.address; // 0x0d86198a785d9cabf3ce9a2032d6cf4a1ec1235b";
    for (let i = 0; i < _tokens.length; i++) {
      queryString += "&token_ids=" + _tokens[i].vid;
    }      
    queryString += "&format=json";
    // Fetch data 
    let openseaData = await fetch(queryString);
    openseaData = await openseaData.json();
    // Retrieve data and update array    
    for (let i = 0; i < _tokens.length; i++) {
      let osElem = openseaData.assets.find(e => e.token_id == _tokens[i].vid);
      if (osElem.sell_orders[0]) {
        _tokens[i].salePrice = osElem.sell_orders[osElem.sell_orders.length-1].current_price;
        _tokens[i].salePrice = web3Infura.utils.fromWei(_tokens[i].salePrice);
        _tokens[i].salePriceUrl = osElem.permalink;
       } 
    }
    return _tokens;
  }


  const shortenAddress = address => {
    return (address.substr(0,6) + "..." + address.substr(address.length-4, 4))
  }
  // One time effect
  useEffect(()=> {
    const ethNetwork = "https://mainnet.infura.io/v3/f83d57a989da429d9c6982a4d09c351d"; //"https://rinkeby.infura.io/v3/f83d57a989da429d9c6982a4d09c351d";
    setWeb3Infura(new Web3(new Web3.providers.HttpProvider(ethNetwork)));
    let gifPage = matchPath(location.pathname, {
      path: "/gif/:id/",
      exact: true,
      strict: false
    });
    if (gifPage) { setIsGifPage(true); }
  }, []);
  // On web3 loaded
  useEffect(() => {
    const fastLoad = async() => {
      const contract = new web3Infura.eth.Contract(blockchain.artblock.abi, blockchain.artblock.address);
      const projectInfo = await contract.methods.projectTokenInfo(blockchain.artblock.projectId).call();
      setArtblockProjectInfo(projectInfo);
      setWeb3InfuraContract(contract);
      setIsLoaded(true); 
    }

    const load = async() => {
      const contract = new web3Infura.eth.Contract(blockchain.artblock.abi, blockchain.artblock.address);
      const projectInfo = await contract.methods.projectTokenInfo(blockchain.artblock.projectId).call();
      setArtblockProjectInfo(projectInfo);
      setWeb3InfuraContract(contract);
      // Get all tokens
      const _tokens = [];
      const artblocks = {};
      setLoadingStatus("Loading tokens from the blockchain...");
      artblocks.tokens = await contract.methods.projectShowAllTokens(blockchain.artblock.projectId).call();
      //console.log("Artblocks Tokens", artblocks.tokens);
      if (!artblocks.tokens) { console.log("Something is wrong", artblocks.tokens)}
      // const offset = ((Math.floor(Math.random() * artblocks.tokens.length)) + 14);
        // offset
        /*
        for (let i = offset; i >= 0; i--) {
        if (i > offset-12) {
        for (let i = artblocks.tokens.length-1; i >= 0; i--) {
        if (i > artblocks.tokens.length-13) {
        */
       for (let i = artblocks.tokens.length-1; i >= 0; i--) {
        if (i > artblocks.tokens.length-10) {
          let newToken = {};
          newToken.id = artblocks.tokens[i] - blockchain.artblock.tokenPrefix;
          newToken.hash = await contract.methods.tokenIdToHash(artblocks.tokens[i]).call();
          newToken.owner = await contract.methods.ownerOf(artblocks.tokens[i]).call();
          newToken.ownerShort = shortenAddress(newToken.owner);
          newToken.ownerUrl = blockchain.etherscan.address + newToken.owner;
          newToken.vid = artblocks.tokens[i];
          newToken.salePrice = null;

            _tokens.push(newToken);
        }
      }
      //console.log("Spectron tokens", _tokens);
      
      // setLoadingStatus("Loading auctions and biddings...");
      // const _tokensOS = [...await getOpenseaData(_tokens)];
      // setTokens(_tokensOS);
      setTokens(_tokens);
      setIsLoaded(true); 

    };
  
    if (typeof web3Infura !== "undefined") {
      if (isGifPage) { 
        fastLoad();
      } else {
        load();
      }
    }
  },[web3Infura]);

  return (
  <>
    <AnimatePresence>
    {!canvas.enabled ? null : <Canvas element={"h" + canvas.token.vid} blockchain={blockchain} setModal={setModal} token={canvas.token} display={canvas.display} setFullscreenCanvas={setCanvas} /> }
    {!modal.enabled ? null : <Modal key="modal" passSetModal={setModal} passModal={modal} /> }
    </AnimatePresence>
    {!isLoaded ? (
      <Intro loadingStatus={loadingStatus} /> 
    ):( 
      <div className="container sp-wrapper">
        {isGifPage || (
        <Header setModal={setModal} blockchain={blockchain}  />
        )}  
          <Switch>
            <Route path="/about">
              <About setCanvas={setCanvas} blockchain={blockchain} tokenList={tokens} />
            </Route>
            <Route path="/gallery">
              <Gallery setCanvas={setCanvas} blockchain={blockchain} setModal={setModal} tokenList={tokens} />
            </Route>
            <Route path="/buy">
              {isConnectedMetamask ? <Buy setCanvas={setCanvas} setModal={setModal} setTokens={setTokens} tokenList={tokens} blockchain={blockchain} /> : <Forbidden/>}
            </Route>
            <Route path="/gif/:id">
              <GifExport blockchain={blockchain} fastload={isGifPage} />
            </Route>
            <Route path="/gif/">
              <Redirect to="/" />
            </Route>
            <Route path="/">
              <Homepage setCanvas={setCanvas} tokenList={tokens} blockchain={blockchain} />
            </Route>
          </Switch>
      </div>
    )}
  </>
  )
}

export default App;




